// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nB8F","controls":"styles_controls__1_KIo","charLimit":"styles_charLimit__2uych","input":"styles_input__CA4cP","send":"styles_send__14r0-"};